import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  siteName: "MyPages",
  siteSettings: {
    favicon: "",
    logo: "Upguides-logo-white-red.svg"
  },
  countries: []
}

// mutations
export const mutations = {

  [types.INITIAL_DATA_SAVE] (state, { appdata }) {
    state.countries = appdata
  },

}

// actions
export const actions = {

  async fetchInitialData ({ commit }) {
    try {
      const { data } = await axios.get(process.env.API_URL+'/appdata')
      commit(types.INITIAL_DATA_SAVE, { appdata: Object.values(data.countries) })
    } catch (e) {
      //commit(types.FETCH_USER_FAILURE)
    }
  }

}

// getters
export const getters = {
  siteSettings: state => state.siteSettings,
  siteName: state => state.siteName,
  countries: state => state.countries,
}



// WEBPACK FOOTER //
// ./src/store/modules/site.js